import React from 'react'
import { connect } from 'react-redux';
import { updateBetSlip } from '../../../redux/actions/betSlipActions'
import { SessionStorage } from '../../../helpers';
import {Icon} from 'antd'
import Images from '../../common/Images'


class OddFieldCircle extends React.Component {

    render() {
        const { position, oddField , zoom} = this.props;
        return (
            <div
                onClick={e => this.onFieldClick(e, oddField)}
                style={zoom? {display: 'flex' ,justifyContent: 'center'}  : null }
                className={`SW SW-${position} ${this.props.betSlipField ? 'selected-odd' : ''}`}>
                  {this.props.betSlipField && (zoom ?
                  <img src={Images.Check} alt="check" style={{ position: 'absolute', width: 11, height: 18 }} />
                  :
                  <img src={Images.Thumb} alt="thumb"/>)
                  }
            </div>
        )
    }

    onFieldClick(e, field) {
        if (this.props.clickable) {
            e.preventDefault();
            e.stopPropagation();

            const { updateBetSlip } = this.props;
            let betTab = SessionStorage.betTab;
            if (betTab == 1) {
                updateBetSlip({ ...field, amount: (!this.props.hideStake && this.props.amount) || 100 });
            }
            else {
                updateBetSlip(field);
            }
        }

    }

}

const mapStateToProps = (_, initialProps) => (state) => {
    return {
        betSlipField: state.betSlip.betSlipList[initialProps.oddFieldId],
        amount: state.betSlip.amount,
        hideStake: state.betSlip.hideStake
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateBetSlip: (field) => {
            dispatch(updateBetSlip(field));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OddFieldCircle)